<template>
  <div class="project-edit">
    <app-view-layout
      header="Edycja projektu"
      :subheader="project.name"
    >
      <template #toolbarMenu>
        <AppNavigateBack
          :prev-route="prevRoute"
          class="mr-4"
        />
      </template>

      <template #content>
        <v-form
          ref="updateProjectForm"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <ProjectFormCard
            v-model="projectData"
            class="mt-4 mb-8"
          />

          <ProjectCampaignsCard
            v-if="tagsAndCampaignsUpdatePermitted"
            v-model="projectData.campaignIds"
            class="mb-8"
            :editable="projectData.editable"
          />

          <ProjectTagsCard
            v-if="tagsAndCampaignsUpdatePermitted"
            v-model="projectData.tagIds"
            class="mb-8"
            :editable="projectData.editable"
          />

          <AppTextCard
            v-model="projectData.description"
            class="mb-8"
            required
            :disabled="!projectData.editable"
            title="Opis projektu"
          />

          <AppTextCard
            v-model="projectData.copy"
            class="mb-8"
            :disabled="!projectData.editable"
            title="Tekst do wykorzystania"
          />

          <v-btn
            class="my-8"
            color="primary"
            type="submit"
            height="40"
            max-width="120"
            :loading="isProcessing"
          >
            Zapisz zmiany
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import navigateBack from '@/helpers/navigateBackMixin';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectFormCard from '@/components/Projects/ProjectFormCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import AppNavigateBack from '@/components/UI/AppNavigateBack.vue';
import ProjectTagsCard from '@/components/Projects/ProjectTagsCard.vue';
import ProjectCampaignsCard from '@/components/Projects/ProjectCampaignsCard.vue';

export default {
  components: {
    AppViewLayout,
    ProjectFormCard,
    AppTextCard,
    AppNavigateBack,
    ProjectTagsCard,
    ProjectCampaignsCard,
  },

  mixins: [navigateBack],

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      isFormValid: true,
      projectData: {
        name: '',
        projectType: '',
        mediumIds: [],
        tagIds: [],
        campaignIds: [],
        deadline: '',
        description: '',
        discLocation: '',
        copy: '',
        priority: 'Standardowy',
      },
    };
  },

  computed: {
    ...mapState('project', [
      'project',
      'isProcessing',
    ]),

    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),

    tagsAndCampaignsUpdatePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
  },

  created() {
    this.fetchProject(this.id)
      .then(() => {
        const {
          media, tags, campaigns, softDeleted, ...project
        } = this.project;
        this.projectData = {
          ...project,
          mediumIds: media?.map((medium) => medium.id),
          tagIds: tags?.map((tag) => tag.id),
          campaignIds: campaigns?.map((campaign) => campaign.id),
        };
        this.$refs.updateProjectForm.resetValidation();
      });
  },

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'project-single') this.resetProject();
    next()
  },
  methods: {
    ...mapActions('project', [
      'fetchProject',
      'updateProject',
      'resetProject',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    submit() {
      this.$refs.updateProjectForm.validate();

      if (this.isFormValid) {
        this.updateProject(this.projectData)
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },
  },
};
</script>
